import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Button,
  CardHeader,
  Grid,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { Formik, Form, FieldArray } from "formik";
import {
  AutoCompleteSelect,
  BasicSelect,
  CloseButton,
  MonthAndYearPicker,
  SearchSelect,
  TextInput,
} from "./components";
import moment from "moment";
import { GetSkill } from "../Actions/CommonAction";
import { step3FormSchema } from "./form-schema";
import { selectFilterCities } from "./../Actions/CommonAction";

const proficiencyOptions = [
  { value: "beginner", label: "Beginner" },
  { value: "intermediate", label: "Intermediate" },
  { value: "expert", label: "Expert" },
];

const locationOptions = [
  { value: 1, label: "Meerut" },
  { value: 2, label: "Noida" },
  { value: 3, label: "Delhi" },
];

const skillsOptions = [
  { value: 1, label: "Meerut" },
  { value: 2, label: "Noida" },
  { value: 3, label: "Delhi" },
];

function ProjectsDetails({ showCloseBtn, onCloseClick, idx }) {
  return (
    <Box sx={{ mb: showCloseBtn ? 2 : 0 }}>
      <Grid container spacing={2} sx={{ pb: showCloseBtn ? 2 : 0 }}>
        <Grid item xs={showCloseBtn ? 5 : 6}>
          <TextInput label="Title" name={`projectsDetails.${idx}.title`} />
        </Grid>
        <Grid item xs={3}>
          <MonthAndYearPicker
            label="Start Month & Year"
            name={`projectsDetails.${idx}.startMonthYear`}
          />
        </Grid>
        <Grid item xs={3}>
          <MonthAndYearPicker
            label="End Month & Year"
            name={`projectsDetails.${idx}.endMonthYear`}
          />
        </Grid>
        {showCloseBtn ? (
          <Grid item xs={1}>
            <CloseButton onClick={onCloseClick} />
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <TextInput
            label="Description"
            name={`projectsDetails.${idx}.description`}
          />
        </Grid>
      </Grid>
      {showCloseBtn ? <Divider variant="middle" /> : null}
    </Box>
  );
}

function TrainingAndCertificationDetails({ showCloseBtn, onCloseClick, idx }) {
  return (
    <Box sx={{ mb: showCloseBtn ? 2 : 0 }}>
      <Box sx={{ pb: showCloseBtn ? 2 : 0 }}>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12}>
            <TextInput
              label="Training Role"
              name={`trainingAndCertificationDetails.${idx}.courseName`}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={showCloseBtn ? 5 : 6}>
            <TextInput
              label="Training Description"
              name={`trainingAndCertificationDetails.${idx}.instituteName`}
            />
          </Grid>
          <Grid item xs={3}>
            <MonthAndYearPicker
              label="Start Month & Year"
              name={`trainingAndCertificationDetails.${idx}.startMonthYear`}
            />
          </Grid>
          <Grid item xs={3}>
            <MonthAndYearPicker
              label="End Month & Year"
              name={`trainingAndCertificationDetails.${idx}.endMonthYear`}
            />
          </Grid>
          {showCloseBtn ? (
            <Grid
              item
              xs={1}
              display="flex"
              justifyContent="center"
              alignItems="flex-start"
            >
              <CloseButton onClick={onCloseClick} />
            </Grid>
          ) : null}
        </Grid>
      </Box>
      {showCloseBtn ? <Divider variant="middle" /> : null}
    </Box>
  );
}

function SkillsDetails({ showCloseBtn, onCloseClick, idx }) {
  const [skills, setSkills] = useState([]);
  const [isFetchingSkills, setIsFetchingSkills] = useState(false);

  useEffect(() => {
    fetchStates();
  }, []);

  async function fetchStates() {
    setIsFetchingSkills(true);
    const response = await GetSkill({ status: 1 });
    const data = response.data.map(({ skillname, skillcode }) => ({
      label:
        skillname.charAt(0).toUpperCase() + skillname.slice(1).toLowerCase(),
      value: skillcode,
    }));
    setSkills(data);
    setIsFetchingSkills(false);
  }

  return (
    <Box sx={{ mb: showCloseBtn ? 2 : 0 }}>
      <Grid container spacing={2} sx={{ pb: showCloseBtn ? 2 : 0 }}>
        <Grid item xs={6}>
          <SearchSelect
            label="Skill Name"
            name={`skillsDetails.${idx}.skillName`}
            options={skills}
          />
        </Grid>
        {/* <Grid item xs={showCloseBtn ? 5 : 6}>
          <BasicSelect
            label="Proficiency"
            name={`skillsDetails.${idx}.proficiency`}
            options={proficiencyOptions}
          />
        </Grid> */}
        {showCloseBtn ? (
          <Grid
            item
            xs={1}
            display="flex"
            justifyContent="start"
            alignItems="start"
          >
            <CloseButton onClick={onCloseClick} />
          </Grid>
        ) : null}
      </Grid>
      {showCloseBtn ? <Divider variant="middle" /> : null}
    </Box>
  );
}

function PreferencelocationDetails({ showCloseBtn, onCloseClick, idx }) {
  const [locOption, setLocOption] = useState([]);
  const getlocation = (val) => {
    selectFilterCities({ city: val }).then((res) => {
      const dummyLocOption = res.data.map((item) => {
        return { value: item.district_id, label: item.name };
      });
      setLocOption(dummyLocOption);
    });
  };
  return (
    <Box sx={{ mb: showCloseBtn ? 2 : 0 }}>
      <Grid container spacing={2} sx={{ pb: showCloseBtn ? 2 : 0 }}>
        <Grid item xs={showCloseBtn ? 5 : 6}>
          <AutoCompleteSelect
            label="Location Name"
            name={`preferencelocationDetails.${idx}.locationname`}
            options={locOption}
            autoComplete={getlocation}
          />
        </Grid>
        {showCloseBtn ? (
          <Grid
            item
            xs={1}
            display="flex"
            justifyContent="start"
            alignItems="start"
          >
            <CloseButton onClick={onCloseClick} />
          </Grid>
        ) : null}
      </Grid>
      {showCloseBtn ? <Divider variant="middle" /> : null}
    </Box>
  );
}

function Projects({ push, remove, form }) {
  const { values } = form;
  const list = values.projectsDetails;
  return (
    <Form>
      <Card sx={{ mb: 2 }}>
        <Typography sx={{ px: 2, py: 1, m: 0 }} variant="subtitle2">
          Project Details
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <CardContent sx={{ p: 0, pt: 0.5, px: 2 }}>
          {list.map((item, idx, list) => (
            <ProjectsDetails
              key={item.id}
              idx={idx}
              showCloseBtn={true}
              onCloseClick={() => remove(idx)}
            />
          ))}
        </CardContent>
        <CardActions sx={{ px: 0 }}>
          <Button
            onClick={() => push({ ...getInitialData("projectsDetails") })}
            size="small"
          >
            Add
          </Button>
        </CardActions>
      </Card>
    </Form>
  );
}

function TrainingAndCertification({ push, remove, form }) {
  const { values } = form;
  const list = values.trainingAndCertificationDetails;
  return (
    <Form>
      <Card sx={{ mb: 2 }}>
        <Typography sx={{ px: 2, py: 1, m: 0 }} variant="subtitle2">
          Training and Certification Details
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <CardContent sx={{ p: 0, pt: 0.5, px: 2 }}>
          {list.map((item, idx, list) => (
            <TrainingAndCertificationDetails
              key={item.id}
              idx={idx}
              showCloseBtn={true}
              onCloseClick={() => remove(idx)}
            />
          ))}
        </CardContent>
        <CardActions sx={{ px: 0 }}>
          <Button
            onClick={() =>
              push({ ...getInitialData("trainingAndCertificationDetails") })
            }
            size="small"
          >
            Add
          </Button>
        </CardActions>
      </Card>
    </Form>
  );
}

function Skills({ push, remove, form }) {
  const { values } = form;
  const list = values.skillsDetails;
  return (
    <Card sx={{ mb: 2 }}>
      <Typography sx={{ px: 2, py: 1, m: 0 }} variant="subtitle2">
        Skills
      </Typography>
      <Divider sx={{ mb: 1 }} />
      <CardContent sx={{ p: 0, pt: 0.5, px: 2 }}>
        {list.map((item, idx, list) => (
          <SkillsDetails
            key={item.id}
            showCloseBtn={true}
            onCloseClick={() => remove(idx)}
            idx={idx}
          />
        ))}
      </CardContent>
      <CardActions sx={{ px: 0 }}>
        <Button
          onClick={() => push({ ...getInitialData("skillsDetails") })}
          size="small"
        >
          Add
        </Button>
      </CardActions>
    </Card>
  );
}

function Preferencelocation({ push, remove, form }) {
  const { values } = form;
  const list = values.preferencelocationDetails;
  return (
    <Card sx={{ mb: 2 }}>
      <Typography sx={{ px: 2, py: 1, m: 0 }} variant="subtitle2">
        Preference Locations
      </Typography>
      <Divider sx={{ mb: 1 }} />
      <CardContent sx={{ p: 0, pt: 0.5, px: 2 }}>
        {list.map((item, idx, list) => (
          <PreferencelocationDetails
            key={item.id}
            showCloseBtn={true}
            onCloseClick={() => remove(idx)}
            idx={idx}
          />
        ))}
      </CardContent>
      <CardActions sx={{ px: 0 }}>
        <Button
          onClick={() =>
            push({ ...getInitialData("preferencelocationDetails") })
          }
          size="small"
        >
          Add
        </Button>
      </CardActions>
    </Card>
  );
}

const getInitialData = (type) => {
  if (type === "projectsDetails") {
    return {
      id: `${moment().unix()}`,
      title: "",
      startMonthYear: new Date(),
      endMonthYear: new Date(),
    };
  } else if (type === "trainingAndCertificationDetails") {
    return {
      id: `${moment().unix()}`,
      instituteName: "",
      courseName: "",
      startMonthYear: new Date(),
      endMonthYear: new Date(),
    };
  } else if (type === "skillsDetails") {
    return { id: `${moment().unix()}`, skillName: "" };
  } else if (type === "preferencelocationDetails") {
    return { id: `${moment().unix()}`, locationname: null };
  }
};

const formikInitialData = {
  projectsDetails: [],
  trainingAndCertificationDetails: [],
  skillsDetails: [],
  preferencelocationDetails: [],
};

function Step3({ getFormValidity, getData, data = {} }) {
  function getInitialData() {
    return {
      projectsDetails:
        data.projectsDetails || formikInitialData.projectsDetails,
      trainingAndCertificationDetails:
        data.trainingAndCertificationDetails ||
        formikInitialData.trainingAndCertificationDetails,
      skillsDetails: data.skillsDetails || formikInitialData.skillsDetails,
      preferencelocationDetails:
        data.preferencelocationDetails ||
        formikInitialData.preferencelocationDetails,
    };
  }

  return (
    <Formik
      initialValues={getInitialData()}
      validationSchema={step3FormSchema}
      render={({ isValid, values }) => {
        getData(3, values);
        getFormValidity(isValid);
        return (
          <Box>
            <FieldArray name="projectsDetails" component={Projects} />
            <FieldArray
              name="trainingAndCertificationDetails"
              component={TrainingAndCertification}
            />
            <FieldArray name="skillsDetails" component={Skills} />
            <FieldArray
              name="preferencelocationDetails"
              component={Preferencelocation}
            />
          </Box>
        );
      }}
    />
  );
}

export default Step3;
